import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Globals } from '../../models/common/Globals';


@Injectable({
  providedIn: 'root'
})
export class RootScopeService {
  globals = new Globals();
  private _failedUploadsFlag = new BehaviorSubject<boolean | undefined>(undefined);
  private _dbAdminFlag = new BehaviorSubject<boolean | undefined>(undefined);
  private _launchDarklyReady = new BehaviorSubject<boolean>(false);

  failedUploadsFlag() {
    return this._failedUploadsFlag;
  }

  setFailedUploadsFlag(value: boolean): void {
    this._failedUploadsFlag.next(value);
  }

  dbAdminFlag() {
    return this._dbAdminFlag;
  }

  setDbAdminFlag(value: boolean): void {
    this._dbAdminFlag.next(value);
  }

  // Readiness flag to indicate initial LD fetch complete
  setLaunchDarklyReady(val: boolean){
    this._launchDarklyReady.next(val);
  }

  launchDarklyReady(){
    return this._launchDarklyReady.value;
  }

}
